import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { ArrowRightIcon, MapPinIcon } from 'lucide-react';
import { LinkButton } from '../Button';
export function Hero() {
  const reduced = useReducedMotion();
  const rise = (delay: number) => reduced ? {} : {
    initial: {
      opacity: 0,
      y: 16
    },
    animate: {
      opacity: 1,
      y: 0
    },
    transition: {
      duration: 0.3,
      delay,
      ease: [0.23, 1, 0.32, 1] as const
    }
  };
  return <section className="paper-texture relative overflow-hidden bg-paper" aria-label="Introduction" data-id="element-60" data-mp="5pgpv22cmqlc">
      <div className="relative mx-auto grid w-full max-w-shell gap-12 px-5 pb-16 pt-14 sm:px-8 sm:pb-20 sm:pt-20 lg:grid-cols-12 lg:items-center lg:gap-14 lg:pb-28 lg:pt-24" data-id="element-61" data-mp="qdy2jbdqgvb">
        <div className="lg:col-span-6" data-id="element-62" data-mp="3ryrrh650lmuj">
          <motion.p {...rise(0)} className="font-sans text-overline font-semibold uppercase text-gold-dark" data-id="element-63" data-mp="1v4wzsjo3kgca">
            Multi-family office · SEBI Registered Investment Adviser
          </motion.p>

          <motion.h1 {...rise(0.05)} className="mt-6 font-serif text-display text-charcoal" data-id="element-64" data-mp="1mvj9nnp7jhog">
            Family office expertise,
            <span className="block italic text-gold-dark" data-id="element-65" data-mp="1rt2qmvdai8k3">in your city.</span>
          </motion.h1>

          <motion.p {...rise(0.1)} className="mt-7 max-w-xl text-lg leading-relaxed text-charcoal-600" data-id="element-66" data-mp="1d0j1iymz61ln">
            Research, product due diligence and consolidated reporting of a multi family office led by an adviser with fifteen years across public and private markets, who will sit across the table from your family himself.
          </motion.p>

          <motion.div {...rise(0.15)} className="mt-9 flex flex-wrap items-center gap-3" data-id="element-67" data-mp="1vvzfh3tfb0wh">
            <LinkButton to="/contact" size="lg" data-id="element-68" data-mp="20vbytel35pub">
              Book a consultation
              <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-69" data-mp="2ol6bnw5eneek" />
            </LinkButton>
            <LinkButton to="/approach" variant="outline" size="lg" data-id="element-70" data-mp="2tc4w97xfeynm">
              How we work
            </LinkButton>
          </motion.div>

          <motion.p {...rise(0.2)} className="mt-7 text-sm text-charcoal-400" data-id="element-71" data-mp="3373m760kes3n">
            Fee-only advice. No products sold on this call, and no commission-led recommendations.
          </motion.p>
        </div>

        <motion.div {...reduced ? {} : {
        initial: {
          opacity: 0,
          y: 20
        },
        animate: {
          opacity: 1,
          y: 0
        },
        transition: {
          duration: 0.3,
          delay: 0.12,
          ease: [0.23, 1, 0.32, 1] as const
        }
      }} className="relative lg:col-span-6" data-id="element-72" data-mp="2u5vs70530dfd">
          <div className="relative overflow-hidden rounded-sm border border-line bg-cream shadow-lift" data-id="element-73" data-mp="2ajg726i2ctoe">
            <img src="https://cdn.magicpatterns.com/patterns/generated-images/0a1065cf-d2c9-4d66-994a-b37298a1656a.jpg" alt="Three generations of a family sitting together on the verandah of their home" className="h-[22rem] w-full object-cover sm:h-[26rem] lg:h-[32rem]" data-id="element-74" data-mp="26inylfh0mst6" />
          </div>
          <div className="mt-4 flex items-center gap-3 rounded-sm border border-line bg-cream px-4 py-3 shadow-card sm:absolute sm:-bottom-7 sm:left-6 sm:mt-0 sm:max-w-[20rem]" data-id="element-75" data-mp="c1e4fxna8v1b">
            <MapPinIcon className="h-4 w-4 shrink-0 text-gold" aria-hidden="true" data-id="element-76" data-mp="m15042nkxg2z" />
            <p className="text-sm leading-snug text-charcoal-600" data-id="element-77" data-mp="q26yyidl3q4f">
              <span className="font-medium text-charcoal" data-id="element-78" data-mp="pzch8ylygjep">Offices in Bengaluru & Chennai</span> - seven more cities across the south and west by 2028.
            </p>
          </div>
        </motion.div>
      </div>
      <div aria-hidden="true" className="h-px w-full bg-gold/30" data-id="element-79" data-mp="2c4a0b4yv0a1" />
    </section>;
}